import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";
import TablePaginationActions from "../../../shared/components/Table/Actions";
import { dateFormat, dayOfWeekNameByDate } from "../../../util/DateUtil";
import Loading from "../../UI/Loading";

/** Quantidade de aulas por dia da turma - disciplina no bimestre (paginada). */
const CronogramaQuantAulaDiaTable = ({ list, isLoading, onChangePage, onEdit, onDelete }) => {
  if (isLoading) {
    return (
      <Box py={6}>
        <Loading description="Carregando quantidades de aulas..." />
      </Box>
    );
  }

  if (list.content.length === 0) {
    return (
      <Box
        sx={{
          py: 6,
          textAlign: "center",
          color: "text.secondary",
          border: 1,
          borderStyle: "dashed",
          borderColor: "divider",
          borderRadius: 2,
        }}
      >
        <EventNoteOutlinedIcon fontSize="large" />
        <Typography variant="body2" mt={1}>
          Nenhum dia cadastrado neste bimestre.
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <TableContainer sx={{ border: 1, borderColor: "divider", borderRadius: 2 }}>
        <Table size="small" aria-label="Quantidade de aulas por dia">
          <TableHead>
            <TableRow sx={{ "& th": { fontWeight: 600, bgcolor: "action.hover" } }}>
              <TableCell>Data</TableCell>
              <TableCell>Dia da semana</TableCell>
              <TableCell align="right">Quantidade de aulas</TableCell>
              <TableCell align="right" sx={{ width: 96 }} />
            </TableRow>
          </TableHead>
          <TableBody>
            {list.content.map((item) => (
              <TableRow key={item.codigo} hover>
                <TableCell>{item.data ? dateFormat(item.data) : "--"}</TableCell>
                <TableCell sx={{ color: "text.secondary" }}>
                  {item.data ? dayOfWeekNameByDate(item.data) : "--"}
                </TableCell>
                <TableCell align="right">
                  <Typography variant="body2" fontWeight={600}>
                    {item.quantAulas}
                  </Typography>
                </TableCell>
                <TableCell align="right">
                  <Tooltip title="Editar">
                    <IconButton size="small" onClick={() => onEdit(item)}>
                      <EditOutlinedIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Remover">
                    <IconButton size="small" onClick={() => onDelete(item)}>
                      <DeleteOutlineIcon fontSize="small" color="error" />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[]}
        rowsPerPage={list.size || 0}
        component="div"
        count={list.totalElements || 0}
        page={list.number || 0}
        onPageChange={onChangePage}
        labelDisplayedRows={({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? `${count} registros` : `mais de ${to}`}`
        }
        ActionsComponent={TablePaginationActions}
      />
    </>
  );
};

export default CronogramaQuantAulaDiaTable;
